import { Link } from 'react-router-dom';
import PolicyLayout from '../components/PolicyLayout';
import { ADDRESS, COMPANY_NAME, PRODUCT_NAME, SITE_DOMAIN, SITE_NAME, TRADEMARK_OWNERS } from '../constants/site';

export default function TermsPage() {
  return (
    <PolicyLayout
      title="Terms & Conditions"
      intro={`The rules that apply when you use ${SITE_DOMAIN} and the support services offered by ${COMPANY_NAME}.`}
    >
      <h2>1. Acceptance of terms</h2>
      <p>
        By accessing {SITE_DOMAIN} or using any service offered by {COMPANY_NAME} under the {SITE_NAME} name,
        you agree to these Terms &amp; Conditions. If you do not agree, please do not use the website or our services.
      </p>

      <h2>2. Independent service</h2>
      <p>
        {SITE_NAME} is an independent third-party technical support provider. We are not affiliated with,
        authorised by, or endorsed by {TRADEMARK_OWNERS}, or any other software publisher. All trademarks
        are the property of their respective owners and are used only to identify the products we support.
        Official support may be available from the software publisher, in some cases free of charge.
      </p>

      <h2>3. Our services</h2>
      <p>
        We provide guidance and technical assistance for {PRODUCT_NAME} and related software, including
        installation, configuration, troubleshooting, and data organisation. Free guides and initial
        guidance are offered at no cost. Some one-to-one support sessions or plans may be chargeable. Any
        fee is quoted and must be accepted by you before paid work begins.
      </p>
      <p>
        We do not sell software licences, serial numbers, or subscriptions to third-party services unless
        clearly stated, and you are responsible for holding valid licences for any software you ask us to support.
      </p>

      <h2>4. Your responsibilities</h2>
      <ul>
        <li>Provide accurate information about your problem and system.</li>
        <li>Keep current backups of your data before any support session. We strongly recommend this and will help you make one.</li>
        <li>Only grant remote access to computers you own or are authorised to manage.</li>
        <li>Use the website lawfully and not attempt to disrupt, copy, or misuse it.</li>
      </ul>

      <h2>5. Remote access</h2>
      <p>
        Remote sessions take place only with your explicit consent. You may watch the session and end it
        at any time. We will not access files or areas of your computer unrelated to your request.
      </p>

      <h2>6. Payments and refunds</h2>
      <p>
        Prices for paid services are communicated before purchase. Refunds are handled under our{' '}
        <Link to="/refund-policy">Refund Policy</Link>.
      </p>

      <h2>7. No guarantee of results</h2>
      <p>
        We make every reasonable effort to resolve your issue, but some problems are caused by hardware
        faults, third-party services, or software defects outside our control. We cannot guarantee that
        every issue can be resolved.
      </p>

      <h2>8. Limitation of liability</h2>
      <p>
        To the fullest extent permitted by law, {COMPANY_NAME} is not liable for indirect, incidental, or
        consequential damages, including loss of data, arising from use of the website or our services.
        Our total liability for any claim is limited to the amount you paid for the service giving rise to
        the claim.
      </p>

      <h2>9. Website content</h2>
      <p>
        Guides and articles are provided for general information. Software menus and features may differ
        between editions. Content on this website is owned by {COMPANY_NAME} and may not be republished
        without permission.
      </p>

      <h2>10. Changes</h2>
      <p>
        We may update these terms at any time. The “Last updated” date shows the latest version, which
        applies from the moment it is posted.
      </p>

      <h2>11. Governing law</h2>
      <p>These terms are governed by the laws of the State of Wyoming, United States, without regard to conflict-of-law rules.</p>

      <h2>12. Contact</h2>
      <p>
        Questions about these terms? Use live chat or our <Link to="/contact-us">contact form</Link>, or
        write to {COMPANY_NAME}, {ADDRESS}.
      </p>
    </PolicyLayout>
  );
}
